export default __webpack_public_path__ + "static/media/cw.313d8db1.svg";